const styles = `
    &.dn-private {
        background: #F4F5FA;
    }
`;

export default styles;
